/***
*
*   PASSWORD
*   Update the users password
*
*   if the user has a password show old and new inputs
*   if no existing password (eg. in case of social signin)
*   then allow the user to set a password on their account
*
**********/

import React, { Fragment, useContext, useState } from 'react';
import { Animate, AuthContext, Card, Form, Message, AccountNav } from 'components/lib';

export function Password(props){

  const context = useContext(AuthContext);
  const [done, setDone] = useState(false);
  
  return (
    <Fragment>
      <AccountNav/>
      <Animate>

        { !done ?  
          <Card title='Actualiza Tu Contraseña' restrictWidth>
            <Form
              url='/api/user/password'
              method='PUT'
              buttonText='Guardar Contraseña'
              data={{
                ...context.user.has_password && { 
                  oldpassword: {
                    label: 'Antigua contraseña',
                    type: 'password',
                    required: true
                  },
                  has_password: {
                    type: 'hidden',
                    value: true,
                  }
                },
                newpassword: {
                  label: 'Crea nueva contraseña',
                  type: 'password',
                  required: true,
                  complexPassword: true
                },
              }}
              callback={ () => {
                
                setDone(true);
                context.update({ has_password: true });
              
              }}
            />
          </Card>
          : 
          <Message 
            title='Contraseña Guardada'
            type='success'
            text='Tu nueva contraseña ha sido guardada exitosamente.'
           />
          }
      </Animate>
    </Fragment>
  );
}
